import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import { uniqBy } from "lodash";
import take from "lodash/take";
import { useNavigate } from "react-router-dom";
import InfiniteScroll from "../../components/infiniteScroll/InfiniteScroll";
import dayjs from "../../dayjs";
import type { ECommerceOfferWithNames } from "../../eCommerce/eCommerceTypes";
import { useLimit } from "../../misc/useLimit";
import { formatDate } from "../single-package/formatDate";

export function EcommerceOffersDialog(props: {
  offers: ECommerceOfferWithNames[];
  onDetailsClick(): void;
  onClose(): void;
}) {
  const navigate = useNavigate();
  const offers = props.offers;
  const uniqueOffers = uniqBy(
    offers.filter((trip) => trip.start && trip.end),
    (trip) => `${trip.start}-${trip.end}`,
  ).sort((t) => dayjs(t.start).toDate().getUTCSeconds());
  const { limit, loadMore } = useLimit();
  return (
    <Dialog open={true} onClose={props.onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        Terminy w e-commerce
      </DialogTitle>
      <DialogContent
        sx={{
          pt: 2,
          overflow: "visible",
        }}
      >
        <InfiniteScroll
          dataLength={limit < uniqueOffers.length ? limit : uniqueOffers.length}
          hasMore={uniqueOffers.length > limit}
          fetchData={loadMore}
          scrollableTarget={"ecommerce-trips-target"}
          maxHeight={450}
        >
          <Stack
            spacing={2}
            sx={{
              pr: 1,
            }}
          >
            {take(uniqueOffers, limit)
              .filter((trip) => trip.start && trip.end)
              .map((trip) => (
                <Box
                  key={trip.id.value}
                  sx={{ p: 2, borderRadius: 1, bgcolor: "rgba(0,0,0,0.02)", border: "1px solid rgba(0,0,0,0.04)" }}
                >
                  <Stack direction="row" spacing={2} sx={{ mb: 1.5 }}>
                    <Stack
                      direction="row"
                      spacing={0.5}
                      sx={{
                        alignItems: "center",
                      }}
                    >
                      <CalendarTodayIcon sx={{ fontSize: 14, color: "text.secondary" }} />
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: "bold",
                          mb: 1,
                        }}
                      >
                        {formatDate(trip.start!)} - {formatDate(trip.end!)}
                      </Typography>
                    </Stack>
                    <Button size="small" variant="outlined" onClick={() => navigate(`/e-commerce/${trip.id.value}`)}>
                      Otwórz
                    </Button>
                  </Stack>
                </Box>
              ))}
          </Stack>
        </InfiniteScroll>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onDetailsClick} variant="contained" color="primary">
          Szczegóły
        </Button>
        <Button onClick={props.onClose}>Zamknij</Button>
      </DialogActions>
    </Dialog>
  );
}
